export function MockTierList() {
  const mockTiers = [
    { label: "S", labelColor: "#FFFFFF", backgroundColor: "#DC2626" },
    { label: "A", labelColor: "#FFFFFF", backgroundColor: "#C2410C" },
    { label: "B", labelColor: "#000000", backgroundColor: "#FACC15" },
    { label: "C", labelColor: "#FFFFFF", backgroundColor: "#15803D" },
    { label: "D", labelColor: "#FFFFFF", backgroundColor: "#2563EB" },
    { label: "F", labelColor: "#FFFFFF", backgroundColor: "#9333EA" },
  ];

  return (
    <div className="max-w-6xl mx-auto p-6 blur-sm">
      <h1 className="text-3xl font-bold text-white mb-6 opacity-50">
        Example Tier List
      </h1>

      <div className="space-y-2 opacity-50">
        {mockTiers.map((tier) => (
          <div
            key={tier.label}
            className="flex items-stretch min-h-[100px] rounded-lg overflow-hidden"
            style={{
              backgroundColor: `${tier.backgroundColor}20`,
              border: `2px solid ${tier.backgroundColor}`,
            }}
          >
            {/* Tier Label */}
            <div
              className="flex items-center justify-center px-6 min-w-[100px] font-bold text-3xl"
              style={{
                backgroundColor: tier.backgroundColor,
                color: tier.labelColor,
              }}
            >
              {tier.label}
            </div>

            {/* Empty Drop Zone */}
            <div className="flex-1 p-3">
              <div className="flex flex-wrap gap-2 items-start content-start min-h-[80px]">
                <div className="w-full h-full flex items-center justify-center text-muted-foreground text-sm">
                  Drop items here
                </div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
